"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SETTINGS_LABEL_COPY = void 0;
/**
 * The name of the settings screen, on every surface of both clients (BEN-141
 * FP-127(c), Paul 2026-10-07: "Settings" everywhere, one shared string).
 *
 * Web's sidebar said "Account" over a page whose heading said "Settings", and the
 * public deletion page told people to "open Account". One word for one place.
 * Ends in COPY so the copy inventory (scripts/copy-inventory.mjs) picks it up.
 */
// AN-46 (Anthony, 9 Oct; Paul): "Profile and Settings are one screen; call it Profile."
// The sidebar, the page title, the avatar menu and the deletion page's steps all read it.
exports.SETTINGS_LABEL_COPY = "Profile";
//# sourceMappingURL=settingsCopy.js.map